import EMNLP from "../posts/EMNLP";

const blogPosts = [
  // {
  //   id: 2,
  //   title: "Shifting Perspectives Paper: Creating a dial to 'turn down' social bias in LLMs",
  //   date: "2025/03/12",
  //   slug: "shifting-perspectives",
  //   excerpt: "The blog post for the Shifting Perspectives paper.",
  //   component: ShiftingPerspectives
  // },
  {
    id: 1,
    title: "My Favourite EMNLP 2024 Papers",
    date: "2024/12/31",
    slug: "my-favourite-emnlp-papers",
    excerpt: "A silly list of papers I liked that I discovered at EMNLP 2024.",
    component: EMNLP
  }
];

export default blogPosts;
